module.exports = __webpack_public_path__ + "img/couple.40d904fc.svg";